import { toast } from "sonner";
import { Check, Lock } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { formatDateHeure } from "@/lib/format";
import { DEGRADE } from "./commun";

export const FicheMouvement = ({ fiche, onMaj, onAvancer }) => {
  const normales = fiche.etapes_possibles.filter((e) => e.sortie !== "perdu");
  const idx = normales.findIndex((e) => e.code === fiche.etape);
  const cocher = async (c) => {
    try { await api.post(`/fiches/${fiche.id}/conditions/${c.id}`, { cochee: !c.cochee }); onMaj(); } catch (e) { toast.error(messageErreur(e)); }
  };
  const bloque = fiche.conditions_etape.some((c) => c.bloquante && !c.cochee);
  return (
    <section className="at-card p-5 space-y-5" data-testid="view-fiche-mouvement">
      <div className="flex items-baseline justify-between gap-3">
        <p className="at-label">Fiche en mouvement</p>
        <p className="text-3xl font-bold" style={{ color: fiche.temperature || "var(--muted)" }} data-testid="fiche-degrees">{fiche.degres}°</p>
      </div>
      <div>
        <div className="relative h-3 at-pill" style={{ background: DEGRADE }} data-testid="fiche-frise">
          {idx >= 0 && <span className="absolute -top-1.5 w-6 h-6 at-pill border-4" data-testid="fiche-frise-cursor"
            style={{ left: `calc(${normales.length > 1 ? (idx / (normales.length - 1)) * 100 : 0}% - 12px)`, background: "var(--surface)", borderColor: fiche.temperature || "var(--ink)" }} />}
        </div>
        <div className="flex justify-between gap-1 mt-3">
          {normales.map((e, i) => <span key={e.code} className={`text-[11px] leading-tight text-center flex-1 min-w-0 break-words ${i === idx ? "font-bold" : "at-muted"}`}>{e.nom}</span>)}
        </div>
        {fiche.statut !== "en_cours" && <p className="text-sm font-semibold mt-2" data-testid="fiche-frise-statut">{fiche.statut_label}{fiche.motif_perte ? ` · ${fiche.motif_perte}` : ""}</p>}
      </div>
      {fiche.statut === "en_cours" && (
        <div data-testid="fiche-conditions">
          <p className="font-bold mb-2">Pour passer à l'étape suivante{fiche.etape_suivante ? ` (${fiche.etape_suivante.nom})` : ""}</p>
          {fiche.conditions_etape.length === 0 && <p className="text-sm at-muted">Aucune condition définie pour cette étape.</p>}
          <div className="space-y-1.5">
            {fiche.conditions_etape.map((c) => (
              <button key={c.id} type="button" onClick={() => cocher(c)} className="w-full at-soft min-h-[44px] px-3 flex items-center gap-3 text-left text-sm" data-testid={`fiche-condition-${c.id}`}>
                <span className="w-5 h-5 at-pill flex items-center justify-center shrink-0" style={{ background: c.cochee ? "var(--temp-7)" : "var(--surface)", color: "var(--accent-ink)", border: c.cochee ? "2px solid var(--temp-7)" : "2px solid var(--muted)" }}>{c.cochee && <Check size={13} />}</span>
                <span className="flex-1 break-words">{c.libelle}</span>
                {c.bloquante && <span className="text-xs font-bold flex items-center gap-1 at-muted"><Lock size={12} />Bloquante</span>}
              </button>
            ))}
          </div>
          {fiche.etape_suivante?.autorisee && (
            <button type="button" disabled={bloque} onClick={() => onAvancer(fiche.etape_suivante.code)} className="at-btn at-btn-primary w-full mt-3 disabled:opacity-50" data-testid="fiche-advance">
              Avancer → {fiche.etape_suivante.nom}
            </button>
          )}
        </div>
      )}
      <div data-testid="fiche-moves">
        <p className="font-bold mb-2">Déplacements</p>
        {fiche.deplacements.length === 0 && <p className="text-sm at-muted">Aucun déplacement pour le moment.</p>}
        <ol className="space-y-1.5">
          {fiche.deplacements.map((d) => (
            <li key={d.id} className="text-sm at-soft px-3 py-2 break-words"><span className="at-muted text-xs block">{formatDateHeure(d.date)} · {d.auteur_nom}</span>{d.texte}</li>
          ))}
        </ol>
      </div>
    </section>
  );
};
